import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Loading } from '@/kit';

/**
 * Bajo demanda, como las 12 del portal Retail Admin. El import va al ARCHIVO y no al barrel
 * `@/domains/credit`, que arrastraría las demás pantallas al mismo chunk y anularía el split.
 */
const PromotionsPage = lazy(() =>
    import('@/domains/credit/promotions/PromotionsPage').then((m) => ({
        default: m.PromotionsPage,
    })),
);

// Ruta estática: gana sobre la dinámica hermana `$section` (que sigue cubriendo el resto).
export const Route = createFileRoute('/_backoffice/credit/promotions')({
    component: CreditPromotions,
});

function CreditPromotions() {
    return (
        <Suspense fallback={<Loading fullScreen text="Cargando promociones…" />}>
            <PromotionsPage />
        </Suspense>
    );
}
